import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { installSessionExpiryHandlers } from './utils/sessionExpiry';

// Install global 401/session-expiry handlers BEFORE any app code runs so that
// the very first axios/fetch call (including the boot-time /api/auth/me
// check) is covered.
installSessionExpiryHandlers();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
